export default __webpack_public_path__ + "static/media/search-24px.7b12ae00.svg";